export const replaceString = (value: string) => {
  return value
    .replace(/ApplicantName/gi, '{{applicant.name}}')
    .replace(/JobTitle/gi, '{{applicant.vacancy.title}}');
};
